import { createFeatureSelector } from '@ngrx/store';

export const onlineMenuProductsImagesState = createFeatureSelector<OLO.State, OLO.State.OnlineMenuPageProductsImages[]>('onlineMenuProductsImages');
